const helpType = {
    Account: 0,
    Operator: 1
}

export default helpType